import { createReducer, on } from '@ngrx/store';
import {
  OdbCoverDetailDivisionType,
  IOdbCoverDetailDivisionSummaryCategories,
  IOdbBillCategoryDetailsResponse,
  IEMData,
} from '@dch/billing-business-logic';
import * as OdbCategoryDetailsActions from '../actions/odb-category-details.actions';

export interface IOdbBillCategoryDetailsState {
  odbBillCategoryDetailsByDocumentReference: {
    [documentReference: string]: {
      [category in
        | keyof IOdbCoverDetailDivisionSummaryCategories
        | OdbCoverDetailDivisionType]?: IEMData<IOdbBillCategoryDetailsResponse>;
    };
  };
}

export const initialState: IOdbBillCategoryDetailsState = {
  odbBillCategoryDetailsByDocumentReference: {},
};

export const odbCategoryDetailsReducer = createReducer(
  initialState,
  on(
    OdbCategoryDetailsActions.getOdbCategoryDetailsRequest,
    (state, { documentReference, category }) => ({
      ...state,
      odbBillCategoryDetailsByDocumentReference: {
        ...state.odbBillCategoryDetailsByDocumentReference,
        [documentReference]: {
          ...state.odbBillCategoryDetailsByDocumentReference[documentReference],
          [category]: {
            result: null,
            isFetching: true,
            hasError: false,
          },
        },
      },
    })
  ),
  on(
    OdbCategoryDetailsActions.getOdbCategoryDetailsSuccess,
    (state, { documentReference, category, payload }) => ({
      ...state,
      odbBillCategoryDetailsByDocumentReference: {
        ...state.odbBillCategoryDetailsByDocumentReference,
        [documentReference]: {
          ...state.odbBillCategoryDetailsByDocumentReference[documentReference],
          [category]: {
            result: payload,
            isFetching: false,
            hasError: false,
          },
        },
      },
    })
  ),
  on(
    OdbCategoryDetailsActions.getOdbCategoryDetailsFailure,
    (state, { documentReference, category }) => ({
      ...state,
      odbBillCategoryDetailsByDocumentReference: {
        ...state.odbBillCategoryDetailsByDocumentReference,
        [documentReference]: {
          ...state.odbBillCategoryDetailsByDocumentReference[documentReference],
          [category]: {
            result: null,
            isFetching: false,
            hasError: true,
          },
        },
      },
    })
  )
);
